import moment from "moment";
import { geTdayToPassSunday, setDateFormat } from "../helpers/dateHelpers";
import { TemplateDetailUser } from "../pages/common";
import { isTablet } from "react-device-detect";
export const renderColor = (text, responses, i) => {
	let color = "#B64D34";
	if (responses[i] === text) {
		color = "#459A33";
	} else if (text === "N/A") {
		color = "#454545";
	}
	return <span style={{ color }}>{text}</span>;
};

export const filterValues = (value, record, header) => {
	return record[header.trim().split(" ").join("_")] === value;
};

export const sortPercentages = (a, b, header) => {
    const key = header.trim().split(" ").join("_");

    const value1 = a[key] ? parseInt(a[key].slice(0, -1)) : null;
    const value2 = b[key] ? parseInt(b[key].slice(0, -1)) : null;

    if (value1 === null && value2 === null) return 0; // Ambos son null
    if (value1 === null) return 1; // Mandar `a` al final
    if (value2 === null) return -1; // Mandar `b` al final

    return value1 - value2; // Comparar valores numéricos
};


export const sortNumbers = (a, b, header) => {
	const percentage1 = a[header];
	const percentage2 = b[header];
	return percentage1 - percentage2;
};

export const sortAlphabetically = (a, b, header) => {
    const text1 = a[header]?.toString().toLowerCase() || '';
    const text2 = b[header]?.toString().toLowerCase() || '';

    // Si text1 es nulo o vacío, lo colocamos al final
    if (!text1 && text2) return 1;
    if (!text2 && text1) return -1;
    if (!text1 && !text2) return 0;

    // Comparación normal para valores no nulos o vacíos
    return text1.localeCompare(text2);
};


export const sortTime = (a, b, header) => {
    const key = header.trim().split(" ").join("_");

    const time1 = a[key] ? a[key].split(":") : null;
    const time2 = b[key] ? b[key].split(":") : null;

    if (time1 === null && time2 === null) return 0; // Ambos son null
    if (time1 === null) return 1; // Mandar `a` al final
    if (time2 === null) return -1; // Mandar `b` al final

    const minutes1 = parseInt(time1[0]);
    const minutes2 = parseInt(time2[0]);
    const seconds1 = parseInt(time1[1]);
    const seconds2 = parseInt(time2[1]);

    if (minutes1 !== minutes2) {
        return minutes1 - minutes2;
    }
    return seconds1 - seconds2;
};


export const sortDate = (a, b, header) => {
    const key = header.trim().split(" ").join("_");
    const date1 = moment(a[key]);
    const date2 = moment(b[key]);

    // Manejar fechas nulas o inválidas
    const isDate1Valid = date1.isValid();
    const isDate2Valid = date2.isValid();

    if (!isDate1Valid && !isDate2Valid) return 0; // Ambos nulos
    if (!isDate1Valid) return 1; // date1 nulo, va al final
    if (!isDate2Valid) return -1; // date2 nulo, va al final

    // Comparar fechas válidas
    if (date1.isBefore(date2)) return -1;
    if (date1.isAfter(date2)) return 1;
    return 0;
};


export const filters = [
	{ text: "A", value: "A" },
	{ text: "B", value: "B" },
	{ text: "C", value: "C" },
	{ text: "D", value: "D" },
	{ text: "N/A", value: "N/A" },
];

export const secondsToHms = (d) => {
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor((d % 3600) / 60);

    // Asegurar siempre dos dígitos en horas y minutos
    let hDisplay = h.toString().padStart(2, '0');
    let mDisplay = m.toString().padStart(2, '0');

    return `${hDisplay}:${mDisplay}`;
};

export const getAverageTimePerUser = (arrayData, startDate = geTdayToPassSunday(), endDate = setDateFormat(0, 23)) => {
	const filterDataperDate = filterDataForDates(arrayData, startDate, endDate);
	if (filterDataperDate.length > 0) {
		let sumTime = 0;
		filterDataperDate.forEach((response) => {
			sumTime += response.durationInSeconds;
		});
		return sumTime / filterDataperDate.length;
	}
};

export const getAverageCorrectAnswers = (arrayData, startDate = geTdayToPassSunday(), endDate = setDateFormat(0, 23)) => {
	let average = 0;
	const filterDataperDate = filterDataForDates(arrayData, startDate, endDate);
	filterDataperDate.forEach((element) => {
		average += parseInt(element.Porcentaje_total.split("%")[0]);
	});
	return average / filterDataperDate.length;
};

export const countUsersParticipate = (arrayData, startDate = geTdayToPassSunday(), endDate = setDateFormat(0, 23)) => {
	const filterDataperDate = filterDataForDates(arrayData, startDate, endDate);
	const clearNotDuplicate = filterDataperDate.reduce((acc, current) => {
		const x = acc.find((item) => item.Nombre === current.Nombre);
		if (!x) {
			return acc.concat([current]);
		} else {
			return acc;
		}
	}, []);
	return clearNotDuplicate.length;
};

export const correctResponsesByQuestions = (arrayData, startDate = geTdayToPassSunday(), endDate = setDateFormat(0, 23)) => {
	// const formatedData = [];
	// {
	//     "question": "pregunta texto",
	//     "correct": 7,
	//     "incorrect": 9,
	// }
    const questions = [];
	const filterDataperDate = filterDataForDates(arrayData, startDate, endDate);

    if (filterDataperDate.length > 0 && filterDataperDate[0].responses) {
		Object.keys(filterDataperDate[0].responses).forEach((key) => {
			// res[`${key.trim().split(" ").join("_")}`] = questions[key].answer;
			questions.push({
				question: key,
				title: key.substring(0, 6),
				correct: 0,
				incorrect: 0,
			});
		});
		filterDataperDate.forEach((intent) => {
			questions.forEach((quest, i) => {
                if (intent.responses) {
				if (intent.responses[quest.question] && intent.responses[quest.question].answer === intent.responses[quest.question].correctAnswer) {
					questions[i].correct++;
				} else {
					if (intent.responses[quest.question]) {
						questions[i].incorrect++;
					}
				}
                }
			});
		});
	}

	return questions;
};

export const getAverageRepetitionsforUser = (arrayData, startDate = geTdayToPassSunday(), endDate = setDateFormat(0, 23)) => {
	const filterDataperDate = filterDataForDates(arrayData, startDate, endDate);
	const clearNotDuplicate = filterDataperDate.reduce((acc, current) => {
		const x = acc.find((item) => item.Nombre === current.Nombre);
		if (!x) {
			return acc.concat([current]);
		} else {
			return acc;
		}
	}, []);
	const repetitions = clearNotDuplicate.map((item) => {
		return filterDataperDate.filter((dat) => item.Nombre === dat.Nombre).length;
	});
	return repetitions.reduce((a, b) => a + b, 0) / repetitions.length;
};

export const getUsersPerTime = (arraydata, sumDays = 1, startDate = geTdayToPassSunday(), endDate = setDateFormat(0, 23)) => {
	// console.log("--------**********--------");
	// console.log(startDate);
	// console.log(endDate);
	let constresults = [
		{
			id: "usuarios",
			data: [],
		},
	];
	const differenceinDays = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
	// console.log(differenceinDays);
	for (let i = 0; i <= differenceinDays; i += sumDays) {
		let userSum = 0;
		let dateFlag = new Date(startDate);
		dateFlag.setDate(dateFlag.getDate() + i);
		arraydata.forEach((res) => {
			if (new Date(res.Fecha_y_hora).getTime() <= dateFlag.getTime()) {
				userSum++;
			}
		});
		constresults[0].data.push({ y: userSum, x: `${dateFlag.getDate()}/${dateFlag.getMonth() + 1}/${dateFlag.getFullYear()}` });
	}
	return constresults;
	// console.log(new Date(arraydata[1].Fecha_y_hora));
};

const filterDataForDates = (arrayData, startDate, endDate) => {
	const start = startDate.getTime();
	const end = endDate.getTime();
	return arrayData.filter(
		(intent) =>
			new Date(intent.Fecha_y_hora ? intent.Fecha_y_hora : intent.createdAt).getTime() >= start &&
			new Date(intent.Fecha_y_hora ? intent.Fecha_y_hora : intent.createdAt).getTime() <= end
	);
};

//

export const formatingHeaders = (responses) => {
	if (responses.length <= 0) {
		return [];
	}
	const questions = objetoMasAntiguo(responses).responses;

	// correct anwsers
	const correctAnswers = [];

	let responsesNumber = false;

	Object.keys(questions).forEach((key) => {
		correctAnswers.push(questions[key].correctAnswer);
		// comprobacion si las respuestas son numericas
		if (!isNaN(questions[key].answer)) {
			responsesNumber = true;
		} else {
			responsesNumber = false;
		}
	});

	correctAnswers.unshift("respuestas", "fecha");
	// console.log(correctAnswers);
	//
	const headers = [];
	headers.push({
		dataIndex: "Nombre",
		label: "Nombre",
		key: "Nombre",
		title: "Nombre",
		width: 100,
	});
    headers.push({
        dataIndex: "matricula",
        label: "matricula",
        key: "matricula",
        title: "Matrícula",
        width: 100,
    });
    headers.push({
		dataIndex: "Fecha_y_hora",
		key: "Fecha_y_hora",
		title: "Fecha y hora",
		label: "Fecha y hora",
		// sorter: (a, b) => sortDate(a, b, "Fecha_y_hora"),
		width: 200,
	});

	Object.keys(questions).forEach((key, i) => {
		const title = key;
		headers.push({
			title: title,
			label: title,
			isQuestion: true,
			key: title.trim().split(" ").join("_"),
			width: 200,
			dataIndex: title.trim().split(" ").join("_"),
			filters: filters,
			// need responses
			render: (text) => renderColor(text, correctAnswers, i + 2),
			onFilter: (value, record) => filterValues(value, record, title.trim().split(" ").join("_")),
		});
	});
	// questions.forEach((question) => {
	// 	const title = Object.keys(question)[0];
	// 	headers.push({
	// 		title: title,
	// 		key: title,
	// 		width: 200,
	// 		dataIndex: title.trim().split(" ").join("_"),
	// 		filters: filters,
	// 		// need responses
	// 		// render: (text) => renderColor(text, responses, i),
	// 		// onFilter: (value, record) => filterValues(value, record, title),
	// 	});
	// });
	if (responsesNumber) {
		headers.push({
			dataIndex: "sumatoria",
			sorter: (a, b) => sortNumbers(a, b, "sumatoria"),
			key: "sumatoria",
			title: "Puntaje total",
			fixed: isTablet ? "" : "right",
			width: 150,
		});
	}

	headers.push({
		dataIndex: "tiempo_total",
		sorter: (a, b) => sortPercentages(a, b, "tiempo_total"),
		key: "tiempo_total",
        title: "Tiempo invertido",
        label: "Tiempo invertido",
		fixed: isTablet ? "" : "right",
		width: 130,
	});
	headers.push({
		dataIndex: "grupo",
		sorter: (a, b) => sortPercentages(a, b, "grupo"),
		key: "grupo",
        label: "grupo",
		title: "Grupo",
		fixed: isTablet ? "" : "right",
		width: 130,
	});

	headers.push({
		dataIndex: "Porcentaje_total",
		sorter: (a, b) => sortTime(a, b, "Porcentaje_total"),
		key: "Porcentaje_total",
        title: "Progreso %",
        label: "Progreso %",
		fixed: isTablet ? "" : "right",
		width: 130,
	});
	headers.push({
		dataIndex: "Detalles",
		title: "Detalles",
		label: "Detalles",
		key: "operation",
		fixed: "right",
		width: 70,
		// render: (text, record) => <button onClick={(e) => console.log(e)}>{record.Nombre}</button>,
        render: (text, record) => <TemplateDetailUser grupo={record.grupo} matricula={record.matricula} nameUser={record.Nombre} Fecha_y_hora={record.Fecha_y_hora} />,
	});
	return headers;
};

const objetoMasAntiguo = (arreglo) => {
	if (arreglo.length === 0) return null;

	let objetoMasAntiguo = arreglo[0];
	let fechaMasAntigua = new Date(objetoMasAntiguo.createdAt);

	for (let i = 1; i < arreglo.length; i++) {
		const fechaActual = new Date(arreglo[i].createdAt);
		if (fechaActual < fechaMasAntigua) {
			fechaMasAntigua = fechaActual;
			objetoMasAntiguo = arreglo[i];
		}
	}

	return objetoMasAntiguo;
};

//

export const filterResponsesOnlyLastEntry = (objetos) => {

	const users = {};
	objetos.forEach((objeto) => {
		const matricula = objeto.matricula;
		if (!(matricula in users)) {
			users[matricula] = objeto;
		} else {
			const fechaObjeto = new Date(objeto.Fecha_y_hora);
			const fechaUsuario = new Date(users[matricula].Fecha_y_hora);
			if (fechaObjeto > fechaUsuario) {
				users[matricula] = objeto;
			}
		}
	});
	return Object.values(users);
};

export const filterResponsesLastEntryPerDate = (data) => {
    const lastRecordsMap = new Map();
    data.forEach(record => {
        const matricula = record.matricula;
        const fecha = new Date(record.Fecha_y_hora).toDateString();
        const key = `${matricula}-${fecha}`;
        // Si no existe un registro para esta clave o el actual es más reciente, lo actualizamos
        if (!lastRecordsMap.has(key) || new Date(record.Fecha_y_hora) > new Date(lastRecordsMap.get(key).Fecha_y_hora)) {
            lastRecordsMap.set(key, record);
        }
    });
    return Array.from(lastRecordsMap.values());
};



// 

export const getinfobyModules = (arraydata) => {
    console.log("_____________________________________")
    let endCurses = 0
    let result = {};
    let orderByGroups = {}
    console.log(arraydata)
    arraydata.forEach(element => {
        if (element.M4_L5 && element.M4_L5 === "True") {
            endCurses = endCurses + 1
        }
        if (!orderByGroups[element.grupo]) {
            orderByGroups[element.grupo] = {
                "Modulo I": { corrects: 0, incorrects: 0 },
                "Modulo II": { corrects: 0, incorrects: 0 },
                "Modulo III": { corrects: 0, incorrects: 0 },
                "Modulo IV": { corrects: 0, incorrects: 0 },
                "M1_L1": { corrects: 0, incorrects: 0 },
                "M1_L2": { corrects: 0, incorrects: 0 },
                "M1_L3": { corrects: 0, incorrects: 0 },
                "M1_L4": { corrects: 0, incorrects: 0 },
                "M1_L5": { corrects: 0, incorrects: 0 },
                "M1_L6": { corrects: 0, incorrects: 0 },
                "M2_L1": { corrects: 0, incorrects: 0 },
                "M2_L2": { corrects: 0, incorrects: 0 },
                "M2_L3": { corrects: 0, incorrects: 0 },
                "M2_L4": { corrects: 0, incorrects: 0 },
                "M2_L5": { corrects: 0, incorrects: 0 },
                "M3_L1": { corrects: 0, incorrects: 0 },
                "M3_L2": { corrects: 0, incorrects: 0 },
                "M3_L3": { corrects: 0, incorrects: 0 },
                "M3_L4": { corrects: 0, incorrects: 0 },
                "M4_L1": { corrects: 0, incorrects: 0 },
                "M4_L2": { corrects: 0, incorrects: 0 },
                "M4_L3": { corrects: 0, incorrects: 0 },
                "M4_L4": { corrects: 0, incorrects: 0 },
                "M4_L5": { corrects: 0, incorrects: 0 },
            }
        }
        Object.keys(element).forEach(key => {
            if (/^M\d+_L\d+$/.test(key)) { // Filtrar solo las claves con formato Mx_Ly
                if (!result[key]) {
                    result[key] = { name: key, corrects: 0, incorrects: 0 };
                }
                if (element[key] === "True") {
                    result[key].corrects++;
                    orderByGroups[element.grupo][key].corrects += 1
                } else if (element[key] === "False") {
                    result[key].incorrects++;
                    orderByGroups[element.grupo][key].incorrects += 1
                }
            }
        });
    })
    Object.keys(orderByGroups).forEach(key => {
        Object.keys(orderByGroups[key]).forEach(key2 => {
            if (/^M1+_L\d+$/.test(key2)) {
                orderByGroups[key]["Modulo I"].corrects += orderByGroups[key][key2].corrects
                orderByGroups[key]["Modulo I"].incorrects += orderByGroups[key][key2].incorrects
            }
            if (/^M2+_L\d+$/.test(key2)) {
                orderByGroups[key]["Modulo II"].corrects += orderByGroups[key][key2].corrects
                orderByGroups[key]["Modulo II"].incorrects += orderByGroups[key][key2].incorrects
            }
            if (/^M3+_L\d+$/.test(key2)) {
                orderByGroups[key]["Modulo III"].corrects += orderByGroups[key][key2].corrects
                orderByGroups[key]["Modulo III"].incorrects += orderByGroups[key][key2].incorrects
            }
            if (/^M4+_L\d+$/.test(key2)) {
                orderByGroups[key]["Modulo IV"].corrects += orderByGroups[key][key2].corrects
                orderByGroups[key]["Modulo IV"].corrects += orderByGroups[key][key2].incorrects
            }
        })
    })
    console.log({
        endCurses,
        countResponses: result,
        orderByGroups,
    })
    return {
        endCurses,
        countResponses: result,
        orderByGroups,
    }
}

export const getAverageUsersCemex = (responses) => {
    const [, ...validResponses] = responses;
    const result = validResponses.reduce((prev, current) => {
        const { durationInSeconds, responses } = current;
        if (!responses) return prev;

        const keys = Object.keys(responses);
        if (keys.length === 0) return prev;

        const duration = durationInSeconds / keys.length;

        for (const field of keys) {
            if (!prev.has(field)) {
                prev.set(field, { time: duration, repetitions: 1 });
            } else {
                const data = prev.get(field);
                data.time += duration;
                data.repetitions += 1;
            }
        }

        return prev;
    }, new Map());
    console.log(Object.fromEntries(result))
    return Object.fromEntries(result);
}